// import { useNavigate } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
// import MDAlert from "components/MDAlert";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import SearchIcon from '@mui/icons-material/Search';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from 'moment';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import * as service from '../../services/service';

function ItemReceiptReport() {
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [demandNo, setDemandNo] = useState('');
    const [vendorId, setVendorId] = useState('');
    const [VendorData, setVendorData] = useState([]);
    const [data, setData] = useState([]);
    const [dataError, setDataError] = useState(null);
    const [loading, setLoading] = useState(false);

    // const navigate = useNavigate();
    const getVendors = () => {
        fetch(
            service.VENDOR_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.vendorId, label: item.vendorName }));
                setVendorData(data2);
            });
    };

    const getReport = () => {
        setLoading(true);
        fetch(
            service.GET_ITEM_RECEIPT_REPORT,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    FromDate: fromDate ? moment(fromDate).format("MM/DD/YYYY") : null,
                    ToDate: toDate ? moment(toDate).format("MM/DD/YYYY") : null,
                    VendorId: vendorId.value ? vendorId.value : 0,
                    DemandNo: demandNo,
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId,
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result[0].message.messageType === "Failed") {
                    setDataError(result[0].message.message);
                    setData([]);
                }
                else {
                    setData(result);
                    setDataError('');
                }
            })
            .catch(err => {
                if (err) {
                    setDataError(err);
                };
            });
        setLoading(false);
    };

    useEffect(() => {
        setLoading(true);
        getVendors();
        setLoading(false);
    }, []);

    const vendorChangeHandler = (ev) => {
        setVendorId(ev);
    }

    const submitHandler = e => {
        e.preventDefault();
        setLoading(true);
        getReport();
        setLoading(false);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Item Receipt Report
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                <TableContainer component={Paper} style={{ width: '98%', alignSelf: 'center' }}>
                                    <Table>
                                        <TableRow>
                                            <TableCell>
                                                From Date
                                                <DatePicker
                                                    id="fromDate"
                                                    selected={fromDate}
                                                    onChange={date => setFromDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                To Date
                                                <DatePicker
                                                    id="toDate"
                                                    selected={toDate}
                                                    onChange={date => setToDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <MDInput label="Demand No." value={demandNo}
                                                    name="demandNo"
                                                    onChange={ev => setDemandNo(ev.target.value)}
                                                    id="demandNo"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <div style={{ width: '100%', fontSize: '14px' }}>
                                                    <Dropdown menuClassName='myMenuClassName' id="vendor"
                                                        name="vendor"
                                                        options={VendorData}
                                                        value={vendorId}
                                                        onChange={vendorChangeHandler}
                                                        label="Vendor"
                                                        placeholder="Select Vendor"
                                                    />
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow />
                                        <TableRow>
                                            <TableCell align="center" colSpan={4}>
                                                <MDButton color="info" onClick={submitHandler} endIcon={<SearchIcon />}>
                                                    Show
                                                </MDButton>
                                            </TableCell>
                                        </TableRow>
                                    </Table>
                                </TableContainer>
                            </Card>
                            <Card style={{ alignItems: 'center' }}>
                                <div style={{ fontSize: '12px', color: 'red' }}>{dataError}</div>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '98%', alignSelf: 'center' }}>
                                        <Table id="tblReport" aria-label="simple table">
                                            <TableRow>
                                                <TableCell align="center" colSpan={10}>
                                                    <div style={{ width: '100%', fontSize: '16px', fontWeight: 'bold' }} align='center'>
                                                        महाराष्ट्र शासन
                                                    </div>
                                                    <div style={{ width: '100%', fontSize: '14px', fontWeight: 'bold' }} align='center'>
                                                        {JSON.parse(sessionStorage.getItem('userData')).clientName}
                                                    </div>
                                                    <div style={{ width: '100%', fontSize: '12px', fontWeight: 'bold' }} align='center'>
                                                        {JSON.parse(sessionStorage.getItem('userData')).clientAddress}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Receipt No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Receipt Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Item Category</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Item</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Item Code</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Unit</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Received Quantity</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Dismantled Quantity</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Demand No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Vendor</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow
                                                        key={row.receiptId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell style={{ fontSize: '14px' }}>{row.receiptNo}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{moment(row.receiptDate).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.itemCategory}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.item}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.itemCode}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.unit}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.receivedQuantity}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.dismantledQuantity}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.demandNo}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.vendorName}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <Table>
                                            <TableRow>
                                                <TableCell align="center" colSpan={10}>
                                                    <ReactHTMLTableToExcel table="tblReport" className="info"
                                                        filename="ItemReceiptData" sheet="Sheet" buttonText="EXPORT TO EXCEL"
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        </Table>
                                    </TableContainer>
                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default ItemReceiptReport;